
import { useSelector } from 'react-redux';

import { RootState } from '@share/utils';
import { IHotelInfo, IPackage, IRoomsContent } from '@common-types';
import { IAccount, IHotel } from '@share/common-types';

import { RoomVacation } from '../room-vacation';
import { Room } from '../room';

import './style.scss';

interface IProps {
  hotel: IHotelInfo;
  isVacationRental: boolean | undefined;
  isStaticDetail: boolean | undefined;
  nights: number;
  groupedPackages: IPackage[] | undefined;

  preferredRoomSavingPct: number;
  preferredRoomPackageId: string | undefined | null;
  selectedHotel: IHotel;
  
  getRoomContent: (room: string) => IRoomsContent;
}

const zero = 0;

export function RoomsSearchListItem(props: IProps) {

  const { hotel, isVacationRental, nights, groupedPackages, isStaticDetail, preferredRoomSavingPct, preferredRoomPackageId, selectedHotel, getRoomContent } = props;

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const marginatorStore = useSelector((state: RootState) => state.marginatorStore);
  
  const { account } = loginStore;

  const currentPackage = groupedPackages ? groupedPackages[zero] : undefined;
  const possibleStays = currentPackage?.possibleStays;

  if (!currentPackage && !isStaticDetail) {
    return null;
  }

  if (isVacationRental) {
    return (
      <RoomVacation
        account={account as IAccount}
        key={currentPackage?.packageId}
        nights={!possibleStays?.length ? nights : possibleStays[0].days}
        hotelId={hotel.hotelDetails?.id!}
        groupedPackages={groupedPackages}
        getRoomContent={getRoomContent}
        isPreferred={preferredRoomPackageId === currentPackage?.packageId}
        isStaticDetail={isStaticDetail}
        preferredRoomSavingPct={preferredRoomSavingPct}
        marginator={marginatorStore}
        hotelDetail={hotel.hotelDetails!}
        isVacationRentals={isVacationRental}
      />
    );
  } else {
    return (
      <Room
        account={account as IAccount}
        hotel={selectedHotel}
        key={currentPackage?.packageId}
        nights={nights}
        hotelId={hotel.hotelDetails?.id!}
        groupedPackages={groupedPackages}
        getRoomContent={getRoomContent}
        isPreferred={preferredRoomPackageId === currentPackage?.packageId}
        isStaticDetail={isStaticDetail}
        preferredRoomSavingPct={preferredRoomSavingPct}
        marginator={marginatorStore}
      />
    );
  }
}

